import React from "react";

/*
 * Main
 */

export const HamburgerIcon = (): React.ReactElement => {
    return (
        <svg aria-hidden="true" className="fa-bars" data-icon="bars" data-prefix="fas" role="img" viewBox="0 0 448 512">
            <path
                d="M16 132h416c8.8 0 16-7.2 16-16V76c0-8.8-7.2-16-16-16H16C7.2 60 0 67.2 0 76v40c0 8.8 7.2 16 16 16zm0 160h416c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h416c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16z"
                fill="currentColor"
            />
        </svg>
    );
};
